export default __webpack_public_path__ + "static/instant-push-4a7fb72635581d76e6e393478a14ba11.webp";